import React from "react";
import "../../assets/css/home-page/service.css";

export default function Services() {
  const operations = [
    { title: "Bespoke Reinforcement Layouts", body: "Our in-house design team alters helical wire pitch spacing and longitudinal reinforcement counts to meet unique structural engineering requirements for deep embankments." },
    { title: "Heavy Logistics & Site Placement", details: "Using low-bed specialized freight trailers and high-capacity hydraulic truck cranes, we guarantee safe transit and precision placement into pre-excavated trench lines." },
    { title: "Hydrostatic Real-time Verification", details: "Every production batch undergoes strict quality control protocols, including internal water tightness inspections and precise physical three-edge bearing validation tests." }
  ];

  return (
    <section id="services" className="services-section">
      <div className="container-fluid">
        <div className="services-main-layout">
          <div className="services-sticky-sidebar animate-on-scroll">
            <span className="accent-indicator">End-To-End Deliverables</span>
            <h2>Complete Infrastructure Supply Operations</h2>
            <p>
              We go beyond concrete casting. Our team provides comprehensive technical support and logistics management for national-scale civil infrastructure assets.
            </p>
          </div>

          <div className="services-feed-stack">
            {operations.map((op, index) => (
              <div key={index} className="service-step-node animate-on-scroll">
                <div className="step-numeric-prefix">0{index + 1}</div>
                <div className="step-text-block">
                  <h4>{op.title}</h4>
                  <p>{op.body || op.details}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}